import { codingListConstants } from '../../constants/appConstants';

import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

const PROVIDER_MAPPING_OPTIONS = codingListConstants.providerMappingOptions;
type ProviderMapping = { label: string; id: string };

type ProviderMappingState = {
	providerMapping: {
		options: ProviderMapping[];
		currentSelectedProviderMapOption: ProviderMapping;
	};
};

type ProviderMappingActions = {
	setCurrentSelectedProviderMapOption: (
		currentSelectedProviderMapOption: ProviderMappingState['providerMapping']['currentSelectedProviderMapOption'],
	) => void;
};

export type ProviderMappingSlice = ProviderMappingState & ProviderMappingActions;

const providerMappingInitialState: ProviderMappingState = {
	providerMapping: {
		options: PROVIDER_MAPPING_OPTIONS.map(value => ({
			id: value.toLowerCase().replace(' ', ''),
			label: value,
		})),
		currentSelectedProviderMapOption: {
			id: codingListConstants.providerMappingNoneOption || '', // !! la GET NU AFISEZ CORESPONDING MAPPING
			label: 'Not Mapped',
		},
	},
};

export function providerMappingSlice(set: NamedSet<ZustandStore>): ProviderMappingSlice {
	return {
		...providerMappingInitialState,
		setCurrentSelectedProviderMapOption(
			currentSelectedProviderMapOption: ProviderMappingState['providerMapping']['currentSelectedProviderMapOption'],
		): void {
			set(
				(state: ProviderMappingState) => {
					state.providerMapping.currentSelectedProviderMapOption = currentSelectedProviderMapOption;
					return state;
				},
				false,
				'[setCurrentSelectedProviderMapOption]',
			);
		},
	};
}
